import { useEffect, useState } from "react";
import { useNotificationContext } from "contexts/NotificationContext";
import { useParams } from "react-router-dom";
import { IFleetModel } from "models/fleetModel";
import { fetchFleetModelByIdApi } from "api/fleetModel";

export default function useFleetModelDetail() {
  const id: string = useParams().id!;
  const { showError } = useNotificationContext();
  const [openBan, setOpenBan] = useState<boolean>(false);
  const [openActivate, setOpenActivate] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [data, setData] = useState<{ loading: boolean; data?: IFleetModel }>({
    loading: true,
  });

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [id]);

  const fetchData = async () => {
    setData({ loading: true });
    const { data, error } = await fetchFleetModelByIdApi(id);
    if (data?.data) {
      setData({ loading: false, data: data.data });
    } else showError(error!.message);
  };

  const handleOpenBan = () => setOpenBan(true);
  const handleCloseBan = () => setOpenBan(false);
  const handleOpenActivate = () => setOpenActivate(true);
  const handleCloseActivate = () => setOpenActivate(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);

  return {
    data,
    handleCloseActivate,
    handleCloseBan,
    handleOpenActivate,
    handleOpenBan,
    handleCloseDelete,
    handleOpenDelete,
    openActivate,
    openBan,
    openDelete,
    fetchData,
  };
}
